import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=c8237fbc&scoped=true"
import script from "./BaseDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=c8237fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8237fbc",
  null
  
)

export default component.exports